"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tables = void 0;
exports.Tables = {
    USER: "User",
    COURSE: "Course",
    LESSON: "Lesson",
    BADGE: "Badge",
    LOAN_APPLICATION: "LoanApplication",
    QUIZ_QUESTION: "QuizQuestion",
    ANSWER: "Answer",
    CURRICULUM: "Curriculum",
    PARTNER: "Partner",
    ASSET: "Asset"
};
//# sourceMappingURL=tables.js.map